import { ErrorsState, SubmitCreateLoadingPayload } from "@components/loadingSchedule/CreateLoadingScheduleForm";
import { isEmpty, isNaN } from "lodash";

export const validateSubmitCreateLoading = (payload: SubmitCreateLoadingPayload) => {
  const {
    eventDate,
    eventLocation,
    pic,
    loadingDate,
    loadingTime,
    coordinator,
    inventories
  } = payload;

  let errors: ErrorsState = {};

  let inventoriesError: any = [];

  if(inventories.length > 0) {
    inventories.map(inv => {
      const {
        item,
        quantity,
        unit
      } = inv;
  
      let error = {
        name: isEmpty(item) ? "Nama barang wajib diisi" : null,
        quantity: isNaN(quantity) || quantity === 0 ? "Wajib diisi" : null,
        unit: isEmpty(unit) ? "Wajib diisi" : null
      };
  
      inventoriesError.push(error);
      
      return inv;
    });
  };

  if(isEmpty(eventDate)) errors['eventDate'] = "Wajib diisi";
  if(isEmpty(eventLocation)) errors['eventLocation'] = "Wajib diisi";
  if(isEmpty(pic.name)) errors['picName'] = "Wajib diisi";
  if(isEmpty(pic.phone)) errors['picPhone'] = "Wajib diisi";
  if(isEmpty(loadingDate)) errors['loadingDate'] = "Wajib diisi";
  if(isEmpty(loadingTime)) errors['loadingTime'] = "Wajib diisi";
  if(isEmpty(coordinator.name)) errors['coordinatorName'] = "Wajib diisi";
  if(isEmpty(coordinator.phone)) errors['coordinatorPhone'] = "Wajib diisi";
  
  const isEmptyInventoryErrors = inventoriesError.map((obj: any) => {
    return Object.keys(obj).some(function(k){
      return obj[k] === null
    });
  }).filter((value: boolean) => value === false);

  if(isEmptyInventoryErrors.length > 0) errors["inventories"] = inventoriesError;

  let isValid = isEmpty(errors);
  // let isValid = isEmpty(errors) && isEmptyInventoryErrors.length === 0;
  
  return {
    errors,
    isValid
  };
};